import { execa } from 'execa';
import type { IPackageManager } from '@wix/package-manager';
import stripAnsi from 'strip-ansi';

export const EVENT_LINE = 'line';
export const EVENT_SERVER_ADDRESS = 'server_address';

export function runAstroDev({
  packageManager,
  projectFolder,
  port,
  allowedHosts,
}: {
  packageManager: IPackageManager;
  projectFolder: string;
  port?: number;
  allowedHosts?: string;
}) {
  const binaryArgs = ['astro', 'dev'];

  if (port) {
    binaryArgs.push('--port', `${port}`);
  }

  if (allowedHosts) {
    binaryArgs.push('--allowed-hosts', allowedHosts);
  }

  const { file, args } = packageManager.getRunBinaryCmd(binaryArgs);

  const result = execa(file, args, {
    cwd: projectFolder,
    stdio: 'pipe',
    env: { FORCE_COLOR: '1' },
    cleanup: true,
    windowsHide: false,
  });

  let stdoutBuffer = '';

  result.stdout?.on('data', (chunk) => {
    stdoutBuffer += chunk.toString();
    const lines = stdoutBuffer.split('\n');

    stdoutBuffer = lines.pop() ?? '';
    for (const line of lines) {
      result.stdout?.emit(EVENT_LINE, line);
      if (line.includes('http://')) {
        const match = /(http:\/\/[^\s]+)/.exec(line);
        if (match?.[1]) {
          const address = stripAnsi(match[1]).trim();
          result.stdout?.emit(EVENT_SERVER_ADDRESS, address);
        }
      }
    }
  });

  let stdErrBuffer = '';

  result.stderr?.on('data', (chunk) => {
    stdErrBuffer += chunk.toString();
    const lines = stdErrBuffer.split('\n');

    stdErrBuffer = lines.pop() ?? '';
    for (const line of lines) {
      result.stderr?.emit(EVENT_LINE, line);
    }
  });

  return result;
}
